var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("保险管理系统")]),
            _c("el-breadcrumb-item", [_vm._v("保险申请")]),
            _c("el-breadcrumb-item", [_vm._v("查看详情")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "my-container box-shadow" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "main-info" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: {
                width: "400px",
                "margin-left": "175px",
                "margin-top": "30px",
              },
              attrs: {
                id: "myForm",
                "label-position": _vm.labelPosition,
                model: _vm.form,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "保险金额：", prop: "price" } },
                [
                  _c("el-input", {
                    staticStyle: { float: "left", width: "250px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入保险金额",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "price", _vm._n($$v))
                      },
                      expression: "form.price",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "投保年限：", prop: "yearNo" } },
                [
                  _c("el-input", {
                    staticStyle: { float: "left", width: "250px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入投保年限",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.yearNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "yearNo", $$v)
                      },
                      expression: "form.yearNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "保单号：", prop: "cno" } },
                [
                  _c("el-input", {
                    staticStyle: { float: "left", width: "250px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入保单号",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.cno,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cno", $$v)
                      },
                      expression: "form.cno",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(1),
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.uploading,
                    expression: "uploading",
                  },
                ],
                staticStyle: {
                  "margin-top": "30px",
                  "margin-left": "175px",
                  width: "370px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-upload el-upload--text",
                    staticStyle: { position: "relative" },
                  },
                  [
                    _vm._m(2),
                    _c("input", {
                      staticClass: "hidden-upload",
                      attrs: {
                        id: "uploadDom",
                        accept: ".pdf",
                        type: "file",
                        name: "file",
                      },
                      on: { change: _vm.doUpload },
                    }),
                  ]
                ),
                _c("div", { staticClass: "el-upload__tip" }, [
                  _vm._v("只能上传pdf文件"),
                ]),
                _vm.fileList.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "el-upload-list el-upload-list--text" },
                      _vm._l(_vm.fileList, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "el-upload-list__item is-success",
                          },
                          [
                            _c(
                              "a",
                              { staticClass: "el-upload-list__item-name" },
                              [
                                _c("i", { staticClass: "el-icon-document" }),
                                _vm._v(_vm._s(item.name) + " "),
                              ]
                            ),
                            _vm._m(3, true),
                            _c("i", {
                              staticClass: "el-icon-close",
                              on: {
                                click: function ($event) {
                                  return _vm.deletePdf(index)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "70px" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "200px" },
                  on: { click: _vm.link2Detail },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "200px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.feedback },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: { padding: "20px", "border-bottom": "1px solid #DBDBDB" },
      },
      [
        _c("div", { staticStyle: { "font-size": "22px" } }, [
          _vm._v("投保反馈"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gap" }, [
      _c("div", [_vm._v("电子保单")]),
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "el-button el-button--primary el-button--small",
        attrs: { type: "button" },
      },
      [_c("span", [_vm._v("点击上传")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "el-upload-list__item-status-label" }, [
      _c("i", { staticClass: "el-icon-upload-success el-icon-circle-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }